import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

/**
 * A service dedicated to fetching email content from a Google Sheet.
 * This service extends the base Google Sheets service to handle core API
 * interactions and focuses on providing specific endpoints for email data.
 */
@Injectable({
  providedIn: 'root'
})
export class EmailSheetsService extends GoogleSheetsBaseService {

  constructor() {
    super(); // Calling the parent constructor is no longer strictly necessary with inject(), but it's a good practice to keep.
  }

  /**
   * Gets the first part of the 'assessment completed' email.
   * @returns An observable of the email content.
   */
  getAssessmentCompletedByAssessorEmailPartOne(): Observable<any> {
    return this.getSheetColumnData('communications', 'A2', 'A2');
  }

  /**
   * Gets the second part of the 'assessment completed' email.
   * @returns An observable of the email content.
   */
  getAssessmentCompletedByAssessorEmailPartTwo(): Observable<any> {
    return this.getSheetColumnData('communications', 'A3', 'A3');
  }

  /**
   * Gets the first part of the 'ready for final review' email.
   * @returns An observable of the email content.
   */
  getAssessmentReadyForFinalReviewEmail(): Observable<any> {
    return this.getSheetColumnData('communications', 'B2', 'B2');
  }

  /**
   * Gets the second part of the 'ready for final review' email.
   * @returns An observable of the email content.
   */
  getAssessmentReadyForFinalReviewEmailPartTwo(): Observable<any> {
    return this.getSheetColumnData('communications', 'B3', 'B3');
  }

  /**
   * Gets the first part of the 'final review completed' email.
   * @returns An observable of the email content.
   */
  getAssessmentFinalReviewCompletedEmail(): Observable<any> {
    return this.getSheetColumnData('communications', 'C2', 'C2');
  }

  /**
   * Gets the second part of the 'final review completed' email.
   * @returns An observable of the email content.
   */
  getAssessmentFinalReviewCompletedEmailPartTwo(): Observable<any> {
    return this.getSheetColumnData('communications', 'C3', 'C3');
  }

  /**
   * Gets the top part of the 'assigned to assessor' email.
   * @returns An observable of the email content.
   */
  getAssessmentAssignedToAssessorsEmail(): Observable<any> {
    return this.getSheetColumnData('communications', 'D2', 'D2');
  }

  /**
   * Gets the bottom part of the 'assigned to assessor' email.
   * @returns An observable of the email content.
   */
  getAssessmentAssignedToAssessorsEmailBottom(): Observable<any> {
    return this.getSheetColumnData('communications', 'D3', 'D3');
  }
}
